//import Splide from '@splidejs/splide';

// Import our default css theme for splide
// import '@splidejs/splide/css';

// This should only be output on the frontend of the site - NOT the editor

// document.addEventListener( 'DOMContentLoaded', () => {

//   // Splide
//   const splideProducts = document.querySelectorAll('.splideProducts')

//   if(!!splideProducts && splideProducts.length > 0){
//     splideProducts.forEach(splideProducts => {

//       // Grab the slide interval and convert it to an integer and milliseconds
//       const interval = parseInt(splideProducts.dataset.interval) * 1000 || 3000
//       new Splide(splideProducts, { pagination: false, perMove: 1, heightRatio: false, pauseOnHover: false, interval: interval,
// // marginLeft:'2em',
// // gap    : '2rem',
//   breakpoints: {
//     6000: {
//       perPage: 4,
//       gap    : '2rem',

//     },

//     2000: {
//       perPage: 4,
//       gap    : '2rem',

//     },
//     1834:{
//       perPage: 3,
//       gap    : '2rem',

//     },

//     1294: {
//       perPage: 2,
//       gap    : '2rem',

//     },

//     960: {
//       perPage: 2,
//       gap    : '1.2rem',

//     },
//     550: {
//       perPage: 1,
//       gap    : '0.8rem',


//       //gap    : '8rem',

//     }
//   },


//       }).mount()
//     })
//   }
// })